import type { ReactNode } from 'react'
import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'
import { FooterSection } from '@/pages/landing/sections/FooterSection'
import { useBranding } from '@/branding/BrandingProvider'

/**
 * Minimal chrome for legal/static pages: a logo-only top bar (the landing
 * navbar's #anchors don't exist here) plus the shared footer for a path back.
 */
export function LegalLayout({ title, updated, children }: { title: string; updated: string; children: ReactNode }) {
  const { siteName } = useBranding()
  return (
    <>
      <header className="border-b border-slate-100 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 h-20 flex items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-navy flex items-center justify-center">
              <Icon icon="solar:health-linear" className="text-white text-lg" />
            </div>
            <span className="text-xl font-medium text-navy tracking-tight">{siteName}</span>
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-medium tracking-tight text-navy mb-2">{title}</h1>
        <p className="text-sm text-slate-400 mb-10">Last updated: {updated}</p>
        <div className="prose prose-slate max-w-none [&_h2]:text-navy [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:text-navy [&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:text-slate-600 [&_p]:leading-relaxed [&_p]:mb-4 [&_li]:text-slate-600 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_a]:text-rust">
          {children}
        </div>
      </main>
      <FooterSection />
    </>
  )
}
